import AbstractController from "./AbstractController";

export default class Basket extends AbstractController
{
    constructor() {
        super();

        if (!document.querySelector('.basket-total')) {
            return;
        }

        document.querySelector('.basket-total__promo-code-trigger').addEventListener('click', this.onPromoTriggerClick.bind(this));
        document.querySelector('.basket-total__delivery-sum-city').addEventListener('click', this.onDeliveryCityClick.bind(this));
        document.querySelectorAll('.number-spinner__decrement').forEach((el) => el.addEventListener('click', this.onDecrement.bind(this)));
        document.querySelectorAll('.number-spinner__increment').forEach((el) => el.addEventListener('click', this.onIncrement.bind(this)));
        document.querySelector('.basket-total__promo-code-input-btn').addEventListener('click', this.onCouponSubmit.bind(this));
        document.querySelectorAll('.basket-item__delete').forEach((el) => el.addEventListener('click', this.onItemDeleteClick.bind(this)));
        this.legacy();
    }

    legacy() {
    }

    onPromoTriggerClick(e) {
        e.preventDefault();

        e.target.classList.add('hidden');
        document.querySelector('.basket-total__promo-code-input-wrap').classList.remove('basket-total__promo-code-input-wrap--hidden');
    }

    onDeliveryCityClick(e) {
        e.preventDefault();

        var url = $(e.target).data('ajax-url');

        $.fancybox( url, {
            type: 'ajax',
            padding: 0,
            fitToView: false,
            margin: 10
        });
    }

    onDecrement(e) {
        e.preventDefault();
        let itemNode = e.target.closest('.basket-item');
        legacySetQuantity(itemNode.dataset.id, itemNode.dataset.ratio, 'down', false);
    }

    onIncrement(e) {
        e.preventDefault();
        let itemNode = e.target.closest('.basket-item');
        legacySetQuantity(itemNode.dataset.id, itemNode.dataset.ratio, 'up', false);
    }

    onCouponSubmit(e) {
        e.preventDefault();
        recalcBasketAjax({ 'coupon': document.querySelector('.basket-total__promo-code-input').value });
    }

    onItemDeleteClick(e) {
        e.preventDefault();

        const basketItemId = e.target.closest('.basket-item').dataset.id;
        const basketItem = window.appData.basket.items[basketItemId];

        if (!basketItem) {
            return;
        }

        dataLayer.push({
            "ecommerce": {
                "currencyCode": "RUB",
                "remove": {
                    "products": [
                        {
                            "id": basketItem.productId,
                            "name": basketItem.name,
                            "quantity": basketItem.quantity,
                        }
                    ]
                }
            }
        });

        setTimeout(() => document.location.href = e.target.getAttribute('href'), 30);
    }
}

function legacySetQuantity(basketId, ratio, sign, bUseFloatQuantity) {
    var curVal = parseFloat(BX("QUANTITY_INPUT_" + basketId).value),
        newVal;

    ratio = parseFloat(ratio);
    newVal = (sign === 'up') ? curVal + ratio : curVal - ratio;

    if (newVal < 0) {
        newVal = 0;
    }

    if (bUseFloatQuantity) {
        newVal = newVal.toFixed(2);
    }

    if (ratio > 0 && newVal < ratio) {
        newVal = ratio;
    }

    if (!bUseFloatQuantity && newVal != newVal.toFixed(2)) {
        newVal = newVal.toFixed(2);
    }

    newVal = getCorrectRatioQuantity(newVal, ratio, bUseFloatQuantity);

    BX("QUANTITY_INPUT_" + basketId).value = newVal;
    BX("QUANTITY_INPUT_" + basketId).defaultValue = newVal;

    legacyUpdateQuantity('QUANTITY_INPUT_' + basketId, basketId, ratio, bUseFloatQuantity);
}

function legacyUpdateQuantity(controlId, basketId, ratio, bUseFloatQuantity) {
    var oldVal = BX(controlId).defaultValue,
        newVal = parseFloat(BX(controlId).value) || 0,
        bIsCorrectQuantityForRatio = false;

    if (ratio === 0 || ratio == 1) {
        bIsCorrectQuantityForRatio = true;
    } else {

        var newValInt = newVal * 10000,
            ratioInt = ratio * 10000,
            reminder = newValInt % ratioInt,
            newValRound = parseInt(newVal);

        if (reminder === 0) {
            bIsCorrectQuantityForRatio = true;
        }
    }

    var bIsQuantityFloat = false;

    if (parseInt(newVal) != parseFloat(newVal)) {
        bIsQuantityFloat = true;
    }

    newVal = (bUseFloatQuantity === false && bIsQuantityFloat === false) ? parseInt(newVal) : parseFloat(newVal).toFixed(2);

    if (bIsCorrectQuantityForRatio) {
        BX(controlId).defaultValue = newVal;

        BX("QUANTITY_INPUT_" + basketId).value = newVal;

        // set hidden real quantity value (will be used in actual calculation)
        BX("QUANTITY_" + basketId).value = newVal;

        recalcBasketAjax({});
    }
    else {
        newVal = getCorrectRatioQuantity(newVal, ratio, bUseFloatQuantity);

        if (newVal != oldVal) {
            BX("QUANTITY_INPUT_" + basketId).value = newVal;
            BX("QUANTITY_" + basketId).value = newVal;
            recalcBasketAjax({});
        } else {
            BX(controlId).value = oldVal;
        }
    }
}

function recalcBasketAjax(params) {
    BX.showWait();

    let property_values = {},
        action_var = BX('action_var').value,
        items = document.querySelectorAll('.basket-item'),
        delayedItems = BX('delayed_items'),
        postData,
        i;

    postData = {
        'sessid': BX.bitrix_sessid(),
        'site_id': BX.message('SITE_ID'),
        'props': property_values,
        'action_var': action_var,
        'select_props': BX('column_headers').value,
        'offers_props': BX('offers_props').value,
        'quantity_float': BX('quantity_float').value,
        'count_discount_4_all_quantity': BX('count_discount_4_all_quantity').value,
        'price_vat_show_value': BX('price_vat_show_value').value,
        'hide_coupon': BX('hide_coupon').value,
        'use_prepayment': BX('use_prepayment').value
    };

    postData[action_var] = 'recalculate';

    if (!!params && typeof params === 'object') {
        for (i in params) {
            if (params.hasOwnProperty(i))
                postData[i] = params[i];
        }
    }

    if (!!items && items.length > 0) {
        for (let item of Array.from(items)) {
            postData['QUANTITY_' + item.dataset.id] = BX('QUANTITY_' + item.dataset.id).value;
        }
        /*for (i = 0; items.rows.length > i; i++)
            postData['QUANTITY_' + items.rows[i].id] = BX('QUANTITY_' + items.rows[i].id).value;*/
    }

    BX.ajax({
        url: window.basketAjaxUrl,
        method: 'POST',
        data: postData,
        dataType: 'json',
        onsuccess: function (result) {
            BX.closeWait();
            updateBasketTable(null, result);
        }
    });
}

/**
 * @param basketItemId
 * @param {{BASKET_ID : string, BASKET_DATA : { GRID : { ROWS : {} }}, COLUMNS: {}, PARAMS: {}, DELETE_ORIGINAL : string }} res
 */
function updateBasketTable(basketItemId, res) {
    if (typeof res !== 'object') {
        return;
    }

    let bUseFloatQuantity = (res.PARAMS.QUANTITY_FLOAT === 'Y');

    // update product params after recalculation
    if (!!res.BASKET_DATA) {
        for (let id in res.BASKET_DATA.GRID.ROWS) {
            if (res.BASKET_DATA.GRID.ROWS.hasOwnProperty(id)) {
                let item = res.BASKET_DATA.GRID.ROWS[id];
                let itemElement = document.querySelector(`.basket-item[data-id="${id}"]`);

                if (!itemElement) {
                    continue;
                }

                itemElement.querySelector('[data-var="price"]').innerHTML = item.PRICE_FORMATED;

                if (item.PRICE_FORMATED !== item.FULL_PRICE_FORMATED) {
                    itemElement.querySelector('[data-var="oldPrice"]').innerHTML = item.FULL_PRICE_FORMATED;
                }

                itemElement.querySelector('[data-var="quantityInput"]').value = item.QUANTITY;
                (itemElement.querySelector('[data-var="sum"]') || {}).innerHTML = item.SUM;
            }
        }
    }

    // update coupon info
    if (!!res.BASKET_DATA) {
        couponListUpdate(res.BASKET_DATA);
    }

    // update warnings if any
    if (res.hasOwnProperty('WARNING_MESSAGE')) {
        let warningText = '';

        for (let i = res['WARNING_MESSAGE'].length - 1; i >= 0; i--)
            warningText += res['WARNING_MESSAGE'][i] + '<br/>';

        BX('warning_message').innerHTML = warningText;
    }

    // update total basket values
    if (!!res.BASKET_DATA) {
        document.querySelector('.basket-total [data-var="totalProductSum"]').innerHTML = res['BASKET_DATA']['allSum_FORMATED'];
        document.querySelector('.basket-total [data-var="totalDeliverySum"]').innerHTML = res['BASKET_DATA']['DELIVERY_PRICE_FORMATED'];
        document.querySelector('.basket-total [data-var="totalTotalSum"]').innerHTML = res['BASKET_DATA']['SUM_WITH_DELIVERY_FORMATED'];

        BX.onCustomEvent('OnBasketChange');

        if( window.google_trackConversion ) {
            let prodids = [];

            $.each(res.BASKET_DATA.GRID.ROWS, function(i,e){
                prodids.push(parseInt(e.PRODUCT_ID));
            });

            try {
                window.google_trackConversion({
                    google_conversion_id: 1030111192,
                    google_custom_params: {
                        ecomm_pagetype: 'cart',
                        ecomm_prodid:prodids,
                        ecomm_totalvalue:res.BASKET_DATA.allSum
                    },
                    google_remarketing_only: true
                });
            } catch(e) {console.log(e.message);}
        }
    }
}

// @todo check
function couponListUpdate(res) {
    var couponBlock,
        couponClass,
        fieldCoupon,
        couponsCollection,
        couponFound,
        i,
        j,
        key;

    if (!!res && typeof res !== 'object') {
        return;
    }

    couponBlock = BX('coupons_block');
    if (!!couponBlock) {
        if (!!res.COUPON_LIST && BX.type.isArray(res.COUPON_LIST)) {
            fieldCoupon = BX('coupon');
            if (!!fieldCoupon) {
                fieldCoupon.value = '';
            }
            couponsCollection = BX.findChildren(couponBlock, {
                tagName: 'input',
                property: {name: 'OLD_COUPON[]'}
            }, true);

            if (!!couponsCollection) {
                if (BX.type.isElementNode(couponsCollection)) {
                    couponsCollection = [couponsCollection];
                }
                for (i = 0; i < res.COUPON_LIST.length; i++) {
                    couponFound = false;
                    key = -1;
                    for (j = 0; j < couponsCollection.length; j++) {
                        if (couponsCollection[j].value === res.COUPON_LIST[i].COUPON) {
                            couponFound = true;
                            key = j;
                            couponsCollection[j].couponUpdate = true;
                            break;
                        }
                    }
                    if (couponFound) {
                        couponClass = 'disabled';
                        if (res.COUPON_LIST[i].JS_STATUS === 'BAD')
                            couponClass = 'bad';
                        else if (res.COUPON_LIST[i].JS_STATUS === 'APPLYED')
                            couponClass = 'good';

                        BX.adjust(couponsCollection[key], {props: {className: couponClass}});
                        BX.adjust(couponsCollection[key].nextSibling, {props: {className: couponClass}});
                        BX.adjust(couponsCollection[key].nextSibling.nextSibling, {html: res.COUPON_LIST[i].JS_CHECK_CODE});
                    }
                    else {
                        couponCreate(couponBlock, res.COUPON_LIST[i]);
                    }
                }
                for (j = 0; j < couponsCollection.length; j++) {
                    if (typeof (couponsCollection[j].couponUpdate) === 'undefined' || !couponsCollection[j].couponUpdate) {
                        BX.remove(couponsCollection[j].parentNode);
                        couponsCollection[j] = null;
                    }
                    else {
                        couponsCollection[j].couponUpdate = null;
                    }
                }
            }
            else {
                for (i = 0; i < res.COUPON_LIST.length; i++) {
                    couponCreate(couponBlock, res.COUPON_LIST[i]);
                }
            }
        }
    }
    couponBlock = null;
}

function enterCoupon() {
    var newCoupon = BX('coupon');

    recalcBasketAjax({'coupon': newCoupon.value});
}

/**
 * @param couponBlock
 * @param {COUPON: string, JS_STATUS: string} oneCoupon - new coupon.
 */
function couponCreate(couponBlock, oneCoupon) {
    var couponClass = 'disabled';

    if (!BX.type.isElementNode(couponBlock))
        return;
    if (oneCoupon.JS_STATUS === 'BAD')
        couponClass = 'bad';
    else if (oneCoupon.JS_STATUS === 'APPLYED')
        couponClass = 'good';

    couponBlock.appendChild(BX.create(
        'div',
        {
            props: {
                className: 'bx_ordercart_coupon'
            },
            children: [
                BX.create(
                    'input',
                    {
                        props: {
                            className: couponClass,
                            type: 'text',
                            value: oneCoupon.COUPON,
                            name: 'OLD_COUPON[]'
                        },
                        attrs: {
                            disabled: true,
                            readonly: true
                        }
                    }
                ),
                BX.create(
                    'span',
                    {
                        props: {
                            className: couponClass
                        },
                        attrs: {
                            'data-coupon': oneCoupon.COUPON
                        }
                    }
                ),
                BX.create(
                    'div',
                    {
                        props: {
                            className: 'bx_ordercart_coupon_notes'
                        },
                        html: oneCoupon.JS_CHECK_CODE
                    }
                )
            ]
        }
    ));
}
